<template>
    <div class="card mb-0" v-if="simulations">

        <p class="card-body mt-2" v-if="empty">
            <strong>{{ $t('dashboard.no-simulation') }}</strong>
        </p>

        <div v-if="!empty">

            <el-table class="table-responsive table-flush"
                    :show-header="false"
                    :data="visibleSimulations">

                <el-table-column width="200">
                    <template v-slot="{row}">

                        <h3 class="mb-0">
                            <a href="#" @click.prevent="openSimulation(row)"
                                v-if="row.session && (row.state.published || $permissions.hasRight('dashboard.learners.write'))">
                                {{ row.name }}
                            </a>
                            <span v-else>
                                {{ row.name }}
                            </span>
                            <small v-if="row.remedial">
                                <i class="fas fa-undo ml-1"></i>
                            </small>
                            <i class="fas fa-clipboard-check ml-1" v-if="row.assessment"></i>
                        </h3>

                    </template>
                </el-table-column>

                <el-table-column>
                    <template v-slot="{row}">

                        <div v-if="(row.state.published || row.private) && canShowReview(row)">
                            <!-- Keep it on the same line -->
                            <p class="comment">{{ row.state.comment }}</p>

                            <small class="d-block" v-if="row.state.instructor_name">
                                <i class="fas fa-pencil-alt mr-1"></i> {{ row.state.instructor_name }}
                            </small>
                        </div>

                    </template>
                </el-table-column>
                
            </el-table>
        </div>
    </div>
</template>

<script>
    export default {

        props: {

            learner: {
                type: Object,
                required: true
            },

            registration: {
                type: Object,
            },

            simulations: {
                type: Array,
            },
        },
        
        data() {
            return {
                pinned: this.$auth.getUiConfig('pinned_simulation_in_registration_' + this.registration.id),
            }
        },

        created() {
            this.$eventBus.$on('simulation_pinned', pinned => {
                this.pinned = pinned;
            })
        },

        computed: {
            empty() {
                return this.visibleSimulations.length == 0
            },

            visibleSimulations() {
                let visibleSimulations = this.simulations.filter(sim => !sim.private || this.$permissions.hasRight('dashboard.learners.write'))
                if (!this.pinned) {
                    return visibleSimulations
                }
                let visible = false;
                let pinnedSimulations = [];
                for (const simulation of visibleSimulations) {
                    if (simulation.id == this.pinned) {
                        visible = true;
                    }
                    if (visible) {
                        pinnedSimulations.push(simulation)
                    }
                }
                return pinnedSimulations
            }
        },

        methods: {

            canShowReview(simulation) {
                if (this.$permissions.hasRight('dashboard.overviews.always')) {
                    return true
                }
                if (simulation.private) {
                    return false
                }
                if (this.$permissions.hasRight('dashboard.overviews.closed')) {
                    return this.simulationClosed(simulation)
                }
                if (this.$permissions.hasRight('dashboard.overviews.date-or-closed')) {
                    if (simulation.assessment) {
                        return this.simulationAfterDate(simulation)
                    } else {
                        return this.simulationClosed(simulation)
                    }
                }
                return false
            },

            simulationClosed(simulation) {
                return simulation.state.date
                    && new Date(simulation.state.date) <= new Date()
            },

            simulationAfterDate(simulation) {
                return simulation.state.meta
                    && simulation.state.meta.learner_access_date
                    && new Date(simulation.state.meta.learner_access_date) <= new Date()
            },

            openSimulation(simulation) {
                let routeName = simulation.state.published 
                    ? 'dashboard-learner-simulation'
                    : 'dashboard-learner-simulation-edit'

                this.$router.push({
                    name: routeName,
                    params: {
                        learnerId: this.$route.params.learnerId,
                        registrationId: this.$route.params.registrationId,
                        simulationId: simulation.id,
                    }
                });
            }
        }
    }
</script>

<style scoped>

    .card >>> td {
        padding: 1.5rem 0 1.5rem 1.5rem;
        font-size: 0.8rem;
        vertical-align: top !important;
    }
    .card >>> .comment {
        white-space: pre-wrap;
        font-size: 100%;
    }
    
</style>
